import { ReactCompareSlider, ReactCompareSliderImage, ReactCompareSliderHandle } from "react-compare-slider";
import { GripVertical } from "lucide-react";

export const BeforeAfterSlider = ({ beforeImage, afterImage, beforeLabel = "Before", afterLabel = "After", className = "" }) => (
  <div className={`relative overflow-hidden rounded-3xl shadow-2xl ${className}`} data-testid="before-after-slider">
    <ReactCompareSlider
      itemOne={<ReactCompareSliderImage src={beforeImage} alt={beforeLabel} style={{ objectFit: "cover" }} />}
      itemTwo={<ReactCompareSliderImage src={afterImage} alt={afterLabel} style={{ objectFit: "cover" }} />}
      handle={
        <ReactCompareSliderHandle
          buttonStyle={{
            width: 56, height: 56,
            background: "linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)",
            border: "4px solid white", borderRadius: "50%",
            boxShadow: "0 4px 20px rgba(255, 107, 53, 0.4)",
            display: "flex", alignItems: "center", justifyContent: "center", cursor: "ew-resize",
          }}
          linesStyle={{ width: 5, background: "#ff6b35" }}
        >
          <GripVertical className="w-6 h-6 text-white" />
        </ReactCompareSliderHandle>
      }
      position={50}
      className="w-full h-full"
    />
    <div className="absolute top-3 left-3 px-2 py-1 bg-red-500 text-white text-[10px] font-bold uppercase tracking-wider rounded-full shadow-lg">{beforeLabel}</div>
    <div className="absolute top-3 right-3 px-2 py-1 bg-green-500 text-white text-[10px] font-bold uppercase tracking-wider rounded-full shadow-lg">{afterLabel}</div>
  </div>
);

export default BeforeAfterSlider;
